<template>
  <div id="app">
    <el-scrollbar :native="false" :noresize="false">
      <router-view v-if="isReload"></router-view>
    </el-scrollbar>
    <!-- <el-backtop
      target=".el-scrollbar .el-scrollbar__wrap"
      :visibility-height="50"
    >
      <div class="back-top">返回<br />顶部</div>
    </el-backtop> -->
  </div>
  <!-- <div id="app">
    <el-scrollbar :native="false" :noresize="false">
      <router-view v-if="isReload"></router-view>
    </el-scrollbar>

  </div> -->
</template>
<script>

export default {
  name: "App",
  provide() {
    // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isReload: true,
    };
  },
  computed: {
    topDistance() {
      return "calc(50vh + " + (this.scrolled - 160) + "px" + ")";
    },
  },
  methods: {
    reload() {
      this.isReload = false;
      this.$nextTick(() => {
        this.isReload = true;
      });
    },
  },
};
</script>
<style lang="less">
@import "styles/base";

#app {
  height: 100%;
  overflow: hidden;
  font-family: Microsoft YaHei, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .el-scrollbar {
    height: 100%;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .back-top {
    width: 50px;
    background-color: #f2f5f6;
    text-align: center;
    color: #c60c28;
    padding: 6px;
    font-size: 12px;
  }
}
// 分页下拉框字体颜色
.pageclass .el-select-dropdown__item.selected {
  color: #b71c1c;
}
// 日期选择器颜色
.timeclass .el-date-table td.current:not(.disabled) span {
  color: #fff;
  background-color: #b71c1c;
}
.timeclass .el-date-table td.today span {
  color: #b71c1c;
}
.timeclass .el-date-table td.available:hover {
  color: #b71c1c;
}
.dateclass .el-date-table td.end-date span,
.dateclass .el-date-table td.start-date span {
  color: #fff;
  background-color: #b71c1c;
}
.dateclass .el-date-table td.today span {
  color: #b71c1c;
}
.dateclass .el-date-table td.available:hover {
  color: #b71c1c;
}
.dateclass .el-picker-panel__shortcut:hover {
  color: #b71c1c;
}
</style>
